import { render, staticRenderFns } from "./WlAvatar.vue?vue&type=template&id=05a9458d&"
import script from "./WlAvatar.vue?vue&type=script&lang=ts&"
export * from "./WlAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports